import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\SendingDomainController::store
* @see app/Http/Controllers/Creator/SendingDomainController.php:248
* @route '/app/creator/campaigns-settings/domain'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns-settings/domain',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::store
* @see app/Http/Controllers/Creator/SendingDomainController.php:248
* @route '/app/creator/campaigns-settings/domain'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::store
* @see app/Http/Controllers/Creator/SendingDomainController.php:248
* @route '/app/creator/campaigns-settings/domain'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::store
* @see app/Http/Controllers/Creator/SendingDomainController.php:248
* @route '/app/creator/campaigns-settings/domain'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::store
* @see app/Http/Controllers/Creator/SendingDomainController.php:248
* @route '/app/creator/campaigns-settings/domain'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::detect
* @see app/Http/Controllers/Creator/SendingDomainController.php:234
* @route '/app/creator/campaigns-settings/domain/detect'
*/
export const detect = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: detect.url(options),
    method: 'post',
})

detect.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns-settings/domain/detect',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::detect
* @see app/Http/Controllers/Creator/SendingDomainController.php:234
* @route '/app/creator/campaigns-settings/domain/detect'
*/
detect.url = (options?: RouteQueryOptions) => {
    return detect.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::detect
* @see app/Http/Controllers/Creator/SendingDomainController.php:234
* @route '/app/creator/campaigns-settings/domain/detect'
*/
detect.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: detect.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::detect
* @see app/Http/Controllers/Creator/SendingDomainController.php:234
* @route '/app/creator/campaigns-settings/domain/detect'
*/
const detectForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: detect.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::detect
* @see app/Http/Controllers/Creator/SendingDomainController.php:234
* @route '/app/creator/campaigns-settings/domain/detect'
*/
detectForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: detect.url(options),
    method: 'post',
})

detect.form = detectForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
export const status = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(args, options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns-settings/domain/{sendingDomain}/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
status.url = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sendingDomain: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { sendingDomain: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            sendingDomain: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sendingDomain: typeof args.sendingDomain === 'object'
        ? args.sendingDomain.uuid
        : args.sendingDomain,
    }

    return status.definition.url
            .replace('{sendingDomain}', parsedArgs.sendingDomain.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
status.get = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
status.head = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
const statusForm = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
statusForm.get = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::status
* @see app/Http/Controllers/Creator/SendingDomainController.php:376
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/status'
*/
statusForm.head = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

status.form = statusForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::verify
* @see app/Http/Controllers/Creator/SendingDomainController.php:389
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/verify'
*/
export const verify = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(args, options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns-settings/domain/{sendingDomain}/verify',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::verify
* @see app/Http/Controllers/Creator/SendingDomainController.php:389
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/verify'
*/
verify.url = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sendingDomain: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { sendingDomain: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            sendingDomain: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sendingDomain: typeof args.sendingDomain === 'object'
        ? args.sendingDomain.uuid
        : args.sendingDomain,
    }

    return verify.definition.url
            .replace('{sendingDomain}', parsedArgs.sendingDomain.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::verify
* @see app/Http/Controllers/Creator/SendingDomainController.php:389
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/verify'
*/
verify.post = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::verify
* @see app/Http/Controllers/Creator/SendingDomainController.php:389
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/verify'
*/
const verifyForm = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verify.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::verify
* @see app/Http/Controllers/Creator/SendingDomainController.php:389
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/verify'
*/
verifyForm.post = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: verify.url(args, options),
    method: 'post',
})

verify.form = verifyForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::autoConfigure
* @see app/Http/Controllers/Creator/SendingDomainController.php:319
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/auto-configure'
*/
export const autoConfigure = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autoConfigure.url(args, options),
    method: 'post',
})

autoConfigure.definition = {
    methods: ["post"],
    url: '/app/creator/campaigns-settings/domain/{sendingDomain}/auto-configure',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::autoConfigure
* @see app/Http/Controllers/Creator/SendingDomainController.php:319
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/auto-configure'
*/
autoConfigure.url = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sendingDomain: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { sendingDomain: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            sendingDomain: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sendingDomain: typeof args.sendingDomain === 'object'
        ? args.sendingDomain.uuid
        : args.sendingDomain,
    }

    return autoConfigure.definition.url
            .replace('{sendingDomain}', parsedArgs.sendingDomain.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::autoConfigure
* @see app/Http/Controllers/Creator/SendingDomainController.php:319
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/auto-configure'
*/
autoConfigure.post = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: autoConfigure.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::autoConfigure
* @see app/Http/Controllers/Creator/SendingDomainController.php:319
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/auto-configure'
*/
const autoConfigureForm = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autoConfigure.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::autoConfigure
* @see app/Http/Controllers/Creator/SendingDomainController.php:319
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/auto-configure'
*/
autoConfigureForm.post = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: autoConfigure.url(args, options),
    method: 'post',
})

autoConfigure.form = autoConfigureForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
export const callback = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/app/creator/campaigns-settings/domain/{sendingDomain}/callback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
callback.url = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sendingDomain: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { sendingDomain: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            sendingDomain: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sendingDomain: typeof args.sendingDomain === 'object'
        ? args.sendingDomain.uuid
        : args.sendingDomain,
    }

    return callback.definition.url
            .replace('{sendingDomain}', parsedArgs.sendingDomain.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
callback.get = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
callback.head = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
const callbackForm = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
callbackForm.get = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::callback
* @see app/Http/Controllers/Creator/SendingDomainController.php:346
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}/callback'
*/
callbackForm.head = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

callback.form = callbackForm

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::destroy
* @see app/Http/Controllers/Creator/SendingDomainController.php:406
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}'
*/
export const destroy = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/campaigns-settings/domain/{sendingDomain}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::destroy
* @see app/Http/Controllers/Creator/SendingDomainController.php:406
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}'
*/
destroy.url = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sendingDomain: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { sendingDomain: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            sendingDomain: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sendingDomain: typeof args.sendingDomain === 'object'
        ? args.sendingDomain.uuid
        : args.sendingDomain,
    }

    return destroy.definition.url
            .replace('{sendingDomain}', parsedArgs.sendingDomain.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::destroy
* @see app/Http/Controllers/Creator/SendingDomainController.php:406
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}'
*/
destroy.delete = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::destroy
* @see app/Http/Controllers/Creator/SendingDomainController.php:406
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}'
*/
const destroyForm = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\SendingDomainController::destroy
* @see app/Http/Controllers/Creator/SendingDomainController.php:406
* @route '/app/creator/campaigns-settings/domain/{sendingDomain}'
*/
destroyForm.delete = (args: { sendingDomain: string | { uuid: string } } | [sendingDomain: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const domain = {
    store: Object.assign(store, store),
    detect: Object.assign(detect, detect),
    status: Object.assign(status, status),
    verify: Object.assign(verify, verify),
    autoConfigure: Object.assign(autoConfigure, autoConfigure),
    callback: Object.assign(callback, callback),
    destroy: Object.assign(destroy, destroy),
}

export default domain